import type { ThemeConfig } from 'antd';

/**
 * 运营后台主题：暖棕（主色）+ 鼠尾草绿（成功/辅助）+ 暖灰中性底，呼应品牌「经年叙」的纸本气质。
 * 只覆盖 token，不改任何组件结构；告警/危险色沿用 antd 默认的红橙，保证语义可辨。
 */
export const BRAND = {
  primary: '#8f5a2c',
  primarySoft: '#f3e9de',
  sage: '#5f8f6b',
  pageBg: '#f6f3ee',
  sider: '#fbf9f6',
  border: '#e8e1d8',
} as const;

export const adminTheme: ThemeConfig = {
  token: {
    colorPrimary: BRAND.primary,
    colorSuccess: BRAND.sage,
    colorInfo: BRAND.primary,
    colorLink: BRAND.primary,
    colorBgLayout: BRAND.pageBg,
    colorBorderSecondary: BRAND.border,
    borderRadius: 8,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Segoe UI", sans-serif',
  },
  components: {
    Layout: { siderBg: BRAND.sider, headerBg: '#ffffff', bodyBg: BRAND.pageBg },
    Menu: {
      itemBg: 'transparent',
      itemSelectedBg: BRAND.primarySoft,
      itemSelectedColor: BRAND.primary,
      itemHoverBg: '#f6efe7',
      groupTitleColor: '#8a8178',
      itemBorderRadius: 8,
    },
    Table: {
      headerBg: '#f8f4ee',
      headerColor: '#4a423a',
      rowHoverBg: '#fbf6f0',
      borderColor: BRAND.border,
    },
    Card: { headerFontSize: 16 },
  },
};
